const routerView = {
  template: '<router-view></router-view>'
};

export default [
  {
    name: 'admin Dashboard',
    path: '/dashboard',
    meta: {
      title: '운영자 대시보드'
    },
    component: routerView,
    children: [
      {
        name: 'admin Dashboard',
        path: '/dashboard',
        meta: {
          title: '운영자 대시보드'
        },
        component: () => import(/* webpackChunkName: "DashBoard" */ '@/components/dashboard/adminDashboard') // 홈
      }
    ]
  },
  {
    name: 'systemNotice',
    path: '',
    meta: {
      title: '시스템 공지'
    },
    component: routerView,
    children: [
      {
        name: 'admin_system_notice',
        path: '/system_notice',
        meta: {
          title: '시스템 공지사항 관리'
        },
        component: () => import(/* webpackChunkName: "AdminSystemNotice" */ '@/components/menus/admin/systemNotice/system_notice') // 시스템 공지 > 시스템 공지사항 관리
      },
      {
        name: 'admin_system_notice_edit',
        path: '/system_notice/edit',
        meta: {
          title: '시스템 공지사항 등록'
        },
        component: () => import(/* webpackChunkName: "AdminSystemNoticeNew" */ '@/components/menus/admin/systemNotice/system_notice_edit') // 시스템 공지 > 시스템 공지사항 등록
      },
      {
        name: 'notification_settings',
        path: '/notification_settings',
        meta: {
          title: '알림 설정'
        },
        component: () => import(/* webpackChunkName: "AdminNotificationSettings" */ '@/components/menus/admin/systemNotice/notification_settings') // 시스템 공지 > 알림 설정
      }
    ]
  },
  {
    name: 'brandSetting',
    path: '',
    meta: {
      title: '브랜드 설정'
    },
    component: routerView,
    children: [
      {
        name: 'WorkplaceManagement',
        path: '/brand/brand_management',
        meta: {
          title: '워크플레이스 관리'
        },
        component: () => import(/* webpackChunkName: "AdminBrandManagement" */ '@/views/admin/management/brand/WorkplaceManagement') // 브랜드 설정 > 워크플레이스 관리
      },
      {
        name: 'BrandModify',
        path: '/brand/brand_modify',
        meta: {
          title: '브랜드 상세'
        },
        component: () => import(/* webpackChunkName: "AdminBrandModify" */ '@/views/admin/management/brand/BrandModify') // 브랜드 설정 > 워크플레이스 관리 > 브랜드 상세
      },
      {
        name: 'WorkplaceModify',
        path: '/brand/workplace_modify',
        meta: {
          title: '워크플레이스 상세'
        },
        component: () => import(/* webpackChunkName: "AdminWorkplaceModify" */ '@/views/admin/management/brand/WorkplaceModify') // 브랜드 설정 > 워크플레이스 관리 > 워크플레이스 상세
      },
      {
        name: 'admin_management_member',
        path: '/management/member',
        meta: {
          title: '계정 관리'
        },
        component: () => import(/* webpackChunkName: "AdminMember" */ '@/views/admin/management/brand/Member') // 브랜드 설정 > 계정 관리
      },
      {
        name: 'admin_management_member_modify',
        path: '/management/member/modify/:id',
        meta: {
          title: '계정 수정'
        },
        component: () => import(/* webpackChunkName: "AdminMemberModify" */ '@/views/admin/management/brand/MemberModify') // 브랜드 설정 > 계정 관리 > 계정 수정
      },
      {
        name: 'admin_management_role',
        path: '/management/role',
        meta: {
          title: '역할 관리'
        },
        component: () => import(/* webpackChunkName: "AdminRole" */ '@/views/admin/management/brand/Role') // 브랜드 설정 > 역할 관리
      },
      {
        name: 'admin_management_role_new',
        path: '/management/role/new',
        meta: {
          title: '새 역할'
        },
        component: () => import(/* webpackChunkName: "AdminRoleFormNew" */ '@/views/admin/management/brand/RoleForm') // 브랜드 설정 > 역할 관리 > 새 역할
      },
      {
        name: 'admin_management_role_modify',
        path: '/management/role/modify',
        meta: {
          title: '역할 수정'
        },
        component: () => import(/* webpackChunkName: "AdminRoleFormModify" */ '@/views/admin/management/brand/RoleForm') // 브랜드 설정 > 역할 관리 > 역할 수정
      },
      {
        name: 'admin_privacy_inquiry_log',
        path: '/brand/privacy_inquiry_log',
        meta: {
          title: '개인정보 검색이력'
        },
        component: () => import(/* webpackChunkName: "AdminPrivacyInquiryLog" */ '@/components/menus/admin/brand/PrivacyInquiryLog') // 브랜드 설정 > 개인정보 검색이력
      },
      {
        name: 'admin_security_log',
        path: '/brand/security_log',
        meta: {
          title: '보안설정 이력관리'
        },
        component: () => import(/* webpackChunkName: "AdminSecurityLog" */ '@/views/admin/management/brand/SecurityLog') // 브랜드 설정 > 보안설정 이력관리
      },
      {
        name: 'admin_member_log',
        path: '/brand/member_log',
        meta: {
          title: '계정 접속관리'
        },
        component: () => import(/* webpackChunkName: "AdminMemberLog" */ '@/views/admin/management/brand/MemberLog') // 브랜드 설정 > 멤버 접속관리
      }
    ]
  },
  {
    name: 'counselChannelManagement',
    path: '',
    meta: {
      title: '상담 채널 관리'
    },
    component: routerView,
    children: [
      {
        name: 'admin_module_management',
        path: '/approval/module_management',
        meta: {
          title: '상담 채널 승인'
        },
        component: () => import(/* webpackChunkName: "AdminChannelManagement" */ '@/components/menus/admin/approval/AdminChannelManagement') // 상담 채널 관리 > 상담 채널 승인
      },
      {
        name: 'AiChatbotConnect',
        path: '/approval/ai_chatbot_connect',
        meta: {
          title: 'AI 챗봇 연동'
        },
        component: () => import(/* webpackChunkName: "aiChatbotConnect" */ '@/components/menus/admin/approval/AiChatbotConnect') // 상담 채널 관리 > AI 챗봇 연동
      },
      {
        name: 'AiChatbotCounselTask',
        path: '/approval/ai_chatbot_counsel_task',
        meta: {
          title: 'AI 챗봇 상담 유형'
        },
        component: () => import(/* webpackChunkName: "AiChatbotCounselTask" */ '@/components/menus/admin/approval/AiChatbotCounselTask') // 상담 채널 관리 > AI 챗봇 상담 유형
      },
      {
        name: 'AiChatbotCounselTaskRegistration',
        path: '/approval/ai_chatbot_counsel_task/registration',
        meta: {
          title: 'AI 챗봇 상담 유형 등록'
        },
        component: () =>
          import(/* webpackChunkName: "AiChatbotCounselTaskRegistration" */ '@/components/menus/admin/approval/AiChatbotCounselTaskRegistration') // 상담 채널 관리 > AI 챗봇 상담 유형 관리
      },
      {
        name: 'AiChatbotCounselTaskUpdate',
        path: '/approval/ai_chatbot_counsel_task/update',
        meta: {
          title: 'AI 챗봇 상담 유형 수정'
        },
        component: () => import(/* webpackChunkName: "AiChatbotCounselTaskUpdate" */ '@/components/menus/admin/approval/AiChatbotCounselTaskUpdate') // 상담 채널 관리 > AI 챗봇 상담 유형 관리
      },
      {
        name: 'KtCallConnect',
        path: '/approval/kt_call_connect',
        meta: {
          title: 'KT 상담콜 연동'
        },
        component: () => import(/* webpackChunkName: "AdminCallConnect" */ '@/components/menus/admin/approval/KtCallConnect') // 상담 채널 관리 > KT 상담콜 연동
      },
      {
        name: 'KlcnsCallConnect',
        path: '/approval/klcns_call_connect',
        meta: {
          title: 'KLCNS 상담콜 연동'
        },
        component: () => import(/* webpackChunkName: "AdminCallConnect" */ '@/components/menus/admin/approval/KlcnsCallConnect') // 상담 채널 관리 > KT 상담콜 연동
      },
      {
        name: 'KtCallConnectRegistration',
        path: '/approval/kt_call_connect/registration',
        meta: {
          title: 'KT 상담콜 신청'
        },
        component: () => import(/* webpackChunkName: "AdminCallConnectRegistration" */ '@/components/menus/admin/approval/KtCallConnectRegistration') // 상담 채널 관리 > KT 상담콜 연동 > KT 상담콜 신청
      },
      {
        name: 'KlcnsCallConnectRegistration',
        path: '/approval/klcns_call_connect/registration',
        meta: {
          title: 'KLCNS 상담콜 신청'
        },
        component: () =>
          import(/* webpackChunkName: "AdminCallConnectRegistration" */ '@/components/menus/admin/approval/KlcnsCallConnectRegistration') // 상담 채널 관리 > KLCNS 상담콜 연동 > KT 상담콜 신청
      },
      {
        name: 'AlarmTemplateManagement',
        path: '/approval/alarm_template_management',
        meta: {
          title: '알림톡 템플릿 관리'
        },
        component: () => import(/* webpackChunkName: "AlarmTemplateManagement" */ '@/views/admin/approval/AlarmTemplateManagement') // 상담 채널 관리 > 알림톡 템플릿 관리
      },
      {
        name: 'AlarmTemplateManagementRegistration',
        path: '/approval/alarm_template_management/registration',
        meta: {
          title: '알림톡 템플릿 등록'
        },
        component: () =>
          import(/* webpackChunkName: "AlarmTemplateManagementRegistration" */ '@/views/admin/approval/AlarmTemplateManagementRegistration') // 상담 채널 관리 > 알림톡 템플릿 관리 > 알림톡 템플릿 등록
      }
    ]
  },
  {
    name: 'ticketManagement',
    path: '',
    meta: {
      title: '티켓 관리'
    },
    component: routerView,
    children: [
      {
        name: 'admin_ticket_task_type_management',
        path: '/ticket/ticket_task_type_management',
        meta: {
          title: '티켓 유형 관리'
        },
        component: () => import(/* webpackChunkName: "AdminTaskTypeManagement" */ '@/components/menus/admin/ticket/TaskTypeManagement') // 티켓 관리 > 티켓 유형 관리
      }
    ]
  },
  {
    name: 'billingManagement',
    path: '',
    meta: {
      title: '정산 관리'
    },
    component: routerView,
    children: [
      {
        name: 'admin_billing_account_settlement',
        path: '/billing/BillingAccountSettlement',
        meta: {
          title: '채팅 상담 계정 정산'
        },
        component: () => import(/* webpackChunkName: "AdminBillingAccountSettlement" */ '@/components/menus/admin/billing/BillingAccountSettlement') // 정산 관리 > 채팅 상담 계정 정산
      },
      {
        name: 'admin_billing_management',
        path: '/billing/billing_management',
        meta: {
          title: '콜 요금 조회'
        },
        component: () => import(/* webpackChunkName: "AdminBillingManagement" */ '@/components/menus/admin/billing/billing_management') // 정산 관리 > 통신 요금 조회
      },
      {
        name: 'admin_billing_message_statistics_v2',
        path: '/billing/send_message_statistics_v2',
        meta: {
          title: '메시지 발송 건수'
        },
        component: () => import(/* webpackChunkName: "AdminSendMessageStatisticsV2" */ '@/components/menus/admin/billing/send_message_statistics_v2') // 정산 관리 > 메시지 발송 건수
      },
      {
        name: 'admin_billing_talk',
        path: '/billing/billing_talk',
        meta: {
          title: '상담톡 발송 건수'
        },
        component: () => import(/* webpackChunkName: "AdminBillingTalk" */ '@/components/menus/admin/billing/billing_talk') // 정산 관리 > 상담톡 발송 건수
      },
      {
        name: 'admin_billing_customerAuthentication',
        path: '/billing/billing_customerAuthentication',
        meta: {
          title: '본인인증 발송 건수'
        },
        component: () =>
          import(/* webpackChunkName: "AdminBillingCustomerAuthentication" */ '@/components/menus/admin/billing/billing_customerAuthentication') // 정산 관리 > 본인인증 발송 건수
      },
      {
        name: 'admin_billing_totalInfo',
        path: '/billing/billing_totalInfo',
        meta: {
          title: '정산내역 전체 다운로드'
        },
        component: () => import(/* webpackChunkName: "AdminBillingTotalInfo" */ '@/components/menus/admin/billing/billing_totalInfo') // 정산 관리 > 정산내역 전체 다운로드
      },
      {
        name: 'BillingCommunicationInfo',
        path: '/billing/BillingCommunicationInfo',
        meta: {
          title: '통신 내역 다운로드'
        },
        component: () => import(/* webpackChunkName: "AdminBillingCommunicationInfo" */ '@/components/menus/admin/billing/BillingCommunicationInfo') // 정산 관리 > 통신 내역 다운로드
      }
    ]
  },
  {
    name: 'systemSetting',
    path: '',
    meta: {
      title: '시스템 설정'
    },
    component: routerView,
    children: [
      {
        name: 'admin_management_system_member',
        path: '/management/system_member',
        meta: {
          title: '시스템 멤버 관리'
        },
        component: () => import(/* webpackChunkName: "AdminSystemMember" */ '@/views/admin/management/brand/SystemMember') // 시스템 설정 > 시스템 멤버 관리
      },
      {
        name: 'admin_management_system_member_modify',
        path: '/management/system_member/modify/:accountId',
        meta: {
          title: '시스템 멤버 정보 수정'
        },
        component: () => import(/* webpackChunkName: "AdminSystemMemberModify" */ '@/views/admin/management/brand/SystemMemberModify') // 시스템 설정 > 시스템 멤버 관리 > 시스템 멤버 정보 수정
      },
      {
        name: 'system_security',
        path: '/management/system_security',
        meta: {
          title: '시스템 보안 관리'
        },
        component: () => import(/* webpackChunkName: "AdminSecuritySetting" */ '@/views/admin/management/brand/Security') // 시스템 설정 > 시스템 보안 관리
      }
    ]
  }

  // {
  //   path: '/brand/system_log',
  //   name: 'admin_system_log',
  //   component: () => import(/* webpackChunkName: "AdminSystemLog" */ '@/components/menus/admin/brand/system_log') // 활동 로그
  // },
  // {
  //   path: '/channel/brand_call_management',
  //   name: 'admin_brand_call_management',
  //   component: () => import(/* webpackChunkName: "AdminBrandCallManagement" */ '@/components/menus/admin/approval/BrandCallManagement') // 브랜드 회선 관리
  // },
  // {
  //   path: '/channel/kakao_brand_talk_management',
  //   name: 'admin_kakao_brand_talk_management',
  //   component: () => import(/* webpackChunkName: "AdminKakaoBrandTalkManagement" */ '@/components/menus/admin/channel/kakao_brand_talk_management') // 브랜드톡 채널 관리
  // },
  // {
  //   path: '/billing/send_message_statistics',
  //   name: 'admin_billing_message_statistics',
  //   component: () => import('@/components/menus/admin/billing/send_message_statistics') // 메시지 발송 통계
  // },
  // {
  //   path: '/billing/billing_alarm',
  //   name: 'admin_billing_alarm',
  //   component: () => import(/* webpackChunkName: "AdminBillingAlarm" */ '@/components/menus/admin/billing/billing_alarm') // 알림 발송 건수
  // },
  // {
  //   path: '/billing/billing_brand_talk',
  //   name: 'admin_billing_brand_talk',
  //   component: () => import(/* webpackChunkName: "AdminBillingBrandTalk" */ '@/components/menus/admin/billing/billing_brand_talk') // 브랜드톡 과금 조회
  // }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/default.js